import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/Employee";
import Invoices from "./scenes/invoices";
import Form from "./scenes/form";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import CreateEmployee from "./scenes/Employee/createEmployee";
import UpdateEmployee from "./scenes/Employee/updateEmployee";
import CreateInvoices from "./scenes/invoices/cretateInvoices";
import UpdateInvoices from "./scenes/invoices/updateInvoices";
import InvoiceDetails from "./scenes/invoices/viewInvoice";
import CreateExpenses from "./scenes/expenses/createExpenses";
import ExpenseDetails from "./scenes/expenses/viewExpenses";
import UpdateExpenses from "./scenes/expenses/updateExpenses";
import Expenses from "./scenes/expenses";
import  Inventory  from "./scenes/inventory";
import UpdateInventory from "./scenes/inventory/updateInventory";
import CreateInventory from "./scenes/inventory/createInventory";
import InventoryDetails from "./scenes/inventory/viewInventory";
import CreateDailyConsumption from "./scenes/dailyConsumption/createDailyConsumption";
import UpdateDailyConsumption from "./scenes/dailyConsumption/updateDailyConsumption";
import DailyConsumptionDetails from "./scenes/dailyConsumption/viewDailyConsumption";
import DailyConsumption from "./scenes/dailyConsumption";
import Attendance from "./scenes/attendance";
// import { appWithTranslation } from 'react-i18next';
import './i18n';
import { useTranslation } from "react-i18next";
function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const { i18n } = useTranslation();
  useEffect(() => {
    document.body.dir = i18n.language === "ar" ? "rtl" : "ltr"; // تغيير اتجاه الصفحة
    theme.direction = i18n.language === "ar" ? "rtl" : "ltr"; // تحديث الاتجاه في الثيم
  }, [i18n.language, theme]);
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
            <Sidebar isSidebar={isSidebar} />
          <div className="content">
          <Topbar className="topbar" setIsSidebar={setIsSidebar} />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/employee" element={<Team />} />
                <Route path="/invoices" element={<Invoices />} />
                <Route path="/expenses" element={<Expenses />} />
                <Route path="/form" element={<Form />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/attendance" element={<Attendance />} />
                <Route path="/dailyConsumption" element={<DailyConsumption />} />
                <Route path="/createEmployee" element={<CreateEmployee />} />
                <Route path="/updateEmployee/:id" element={<UpdateEmployee />} />
                <Route path="/createInvoices" element={<CreateInvoices />} />
                <Route path="/UpdateInvoices/:id" element={<UpdateInvoices />} />
                <Route path="/ViewInvoice/:id" element={<InvoiceDetails />} />
                <Route path="/createExpenses" element={<CreateExpenses />} />
                <Route path="/updateExpenses/:id" element={<UpdateExpenses />} />
                <Route path="/ViewExpense/:id" element={<ExpenseDetails />} />
                <Route path="/createInventory" element={<CreateInventory />} />
                <Route path="/updateInventory/:id" element={<UpdateInventory />} />
                <Route path="/ViewInventory/:id" element={<InventoryDetails />} />
                <Route path="/createDailyConsumption" element={<CreateDailyConsumption />} />
                <Route path="/updateDailyConsumption/:id" element={<UpdateDailyConsumption />} />
                <Route path="/dailyConsumptionDetails/:id" element={<DailyConsumptionDetails />} />
                {/* <Route path="/bar" element={<Bar />} /> */}
                {/* <Route path="/pie" element={<Pie />} /> */}
                {/* <Route path="/line" element={<Line />} /> */}
                {/* <Route path="/faq" element={<FAQ />} /> */}
                {/* <Route path="/calendar" element={<Calendar />} /> */}
                {/* <Route path="/geography" element={<Geography />} /> */}
              </Routes>
            </main>
          </div>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default (App);
